// extracted by mini-css-extract-plugin
export default {"colorSwatchList":"xmqOZtDt54uASMNAVn1D","colorSwatch":"Ee8xHIBi8ptssfm35MiP","selected":"fcegsgFgCBq68qpNZdCX"};